import { useAsync } from 'react-use';

export const EGABINET_NEWS_COUNT = 4;

const NEWS_BASE_URL = window.APP_ENV?.newsEndpoint || 'https://dreryk.pl/wp-json/wp/v2';
const EGABINET_NEWS_URL = `${NEWS_BASE_URL}/posts?categories=2065&per_page=${EGABINET_NEWS_COUNT}`;
const EGABINET_NEWS_TAG_URL = `${NEWS_BASE_URL}/post_type_tax?include[]=`;

type EGabinetNewsTagsData = {
   name: string;
};

export type EGabinetNewsTag = string;

type UseEGabinetNewsTag = {
   egabinetNewsTag: EGabinetNewsTag | undefined;
   egabinetNewsTagLoading: boolean;
   egabinetNewsTagError: Error | undefined;
};

export const useEGabinetNewsTag = (tagId: string): UseEGabinetNewsTag => {
   const { value, loading, error } = useAsync<() => Promise<Array<EGabinetNewsTagsData> | undefined>>(async () => {
      const response = await fetch(EGABINET_NEWS_TAG_URL + tagId);
      const result = await response.json();

      return result;
   }, [tagId]);

   return { egabinetNewsTag: value?.[0]?.name, egabinetNewsTagError: error, egabinetNewsTagLoading: loading };
};

type EGabinetNewsData = {
   title: {
      rendered: string;
   };
   link: string;
   date: string;
   // eslint-disable-next-line camelcase
   post_type_tax: number[];
};

export type EGabinetNews = {
   title: string;
   link: string;
   date: Date;
   tagId: number | undefined;
};

type UseEGabinetNews = {
   egabinetNews: EGabinetNews[] | undefined;
   egabinetNewsLoading: boolean;
   egabinetNewsError: Error | undefined;
};

export const useEGabinetNews = (): UseEGabinetNews => {
   const { value, loading, error } = useAsync<() => Promise<Array<EGabinetNewsData> | undefined>>(async () => {
      const response = await fetch(EGABINET_NEWS_URL);
      const result = await response.json();

      return result;
   });

   const egabinetNews: EGabinetNews[] | undefined = value?.map((result) => ({
      date: new Date(result.date),
      link: result.link,
      tagId: result.post_type_tax[0],
      title: result.title.rendered,
   }));

   return { egabinetNews: egabinetNews, egabinetNewsError: error, egabinetNewsLoading: loading };
};
